import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  group,
} from '@angular/core';
import { OrderService } from '../services/order/order.service';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { forEach } from '@angular/router/src/utils/collection';
import * as _ from 'lodash';
import * as $ from 'jquery';
import { MenuService } from 'app/services/menu/menu.service';
import { ModifiersService } from 'app/services/modifiers/modifiers.service';
import { PricingService } from '../services/pricing/pricing.service';

@Component({
  selector: 'add-to-order',
  templateUrl: './add-to-order.component.html',
  styleUrls: ['./add-to-order.component.scss'],
  animations: [
    trigger('fadeInAnimation', [
      state(
        'start',
        style({
          opacity: 0,
        })
      ),
      state(
        'end',
        style({
          opacity: 1,
        })
      ),
      transition('start <=> end', animate('300ms ease-in-out')),
    ]),
  ],
})
export class AddToOrderComponent implements OnInit, OnChanges {
  // Inputs from the menu component
  @Input() addToOrderIsActive: boolean = true;
  @Input() activeOrder: any;
  @Input() itemModifiers: any;

  // Tells the menu component that the order was closes
  @Output() closeOrder: EventEmitter<any> = new EventEmitter();

  // Tells the menu component that the add To Order was selected
  @Output() addToOrder: EventEmitter<any> = new EventEmitter();

  // These props build the item and its modifiers, price, quantitiy etc.
  public itemComment: string = '';
  public itemPriceID: number;
  public itemModifiersID: number;
  public itemAmount: string = '1';
  public state: string = 'start';

  // Modifiers
  public itemModifierGroups = [];
  public singleItemModifierID;
  public multipleItemModifierID;

  public currentModifierIndex;

  public selectedModifiersLeft;

  // Gets inputed to the item modifier component
  public selectedModifierGroup;
  public selectedModifier;
  public selectedModifiers = [];
  public selectedModifiersLength = this.selectedModifiers.length;
  public selectModifierActive: boolean = false;
  public selectedModifierMultiple: boolean;

  public tooManySelected: boolean;
  public showModifierError: boolean;

  public tempSelectedModifiers = [];
  public loadingModifiers: boolean = false;

  constructor(
    private _orderService: OrderService,
    private _menuService: MenuService,
    private _pricingService: PricingService,
    private _modifiersService: ModifiersService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes) {
    console.log(this.activeOrder);
    console.log('changes', changes);

    // Checks the changes to see if the add to order component should animate in
    if (
      changes.addToOrderIsActive.currentValue &&
      !changes.addToOrderIsActive.previousValue
    ) {
      // Animates the add to order component in
      this.state = 'end';

      // Loader Shows
      this.loadingModifiers = true;

      // The item Price ID is set
      this.itemPriceID = this.activeOrder._embedded.price_levels[0].id;

      // Modifier groups array gets reset
      this.itemModifierGroups = [];

      // get all option sets
      let itemOptionSets = this.activeOrder._embedded.option_sets;
      console.log('item option sets,', itemOptionSets);

      // loop through and do a call to all the modifier groups,
      var optionSetCounter = 0;
      itemOptionSets.forEach(item => {
        let modifierGroupURL = item._links.modifier_group.href;
        let { minimum } = item;
        console.log('MINIMUM', minimum);
        // if the option is required grab the modifiers, anything not required can go into comments
        // get the item modifiers
        this._orderService
          .getItemModifiers(modifierGroupURL)
          .then(result => {
            let modifierGroup: any = result;
            modifierGroup.minimum = minimum;
            // Don't add Generic Food Mods
            if (modifierGroup.id !== '63') {
              // put them in an array,
              this._modifiersService
                .getAllModifierGroups()
                .then(result => {
                  let modifierGroupsDB: any = result;
                  console.log('modifiers service', modifierGroupsDB);
                  // Loop through and change the names of the modifiers for easy legibility for the user.
                  modifierGroupsDB.forEach(modifierGroupDB => {
                    if (modifierGroupDB.id === modifierGroup.id) {
                      modifierGroup.name = modifierGroupDB.name;
                    }
                  });

                  this._modifiersService
                    .getAllModifiers()
                    .then(result => {
                      let firebaseModifiers: any = result;
                      console.log('firebase modifiers', result);
                      console.log('modifier group', modifierGroup);

                      // Loop through the two different array to change the names of the modifiers to be more legible for the user.
                      modifierGroup._embedded.modifiers.forEach(
                        (modifier, modifierIndex) => {
                          let modifierID = modifier.id;

                          firebaseModifiers.forEach(
                            (fbModifier, fbModifierIndex) => {
                              let fbID = fbModifier.id;
                              let { removeFromMenu } = fbModifier;

                              // check if the same id/slu
                              if (removeFromMenu && modifierID === fbID) {
                                console.log('removing from menu', modifier);
                                modifierGroup._embedded.modifier.splice(
                                  modifierIndex,
                                  1
                                );
                              } else if (modifierID === fbID) {
                                console.log('name change', modifier);
                                modifier.name = fbModifier.name;
                              }
                            }
                          );
                        }
                      );

                      // for (
                      //   let i = 0;
                      //   i < modifierGroup._embedded.modifiers.length;
                      //   i++
                      // ) {
                      //   let modifier = modifierGroup._embedded.modifiers[i];
                      //   let modifierID =
                      //     modifierGroup._embedded.modifiers[i].id;
                      //   for (let j = 0; j < firebaseModifiers.length; j++) {
                      //     let fbID = firebaseModifiers[j].id;
                      //     let removeFromMenu =
                      //       firebaseModifiers[j].removeFromMenu;
                      //     // check if the same id/slu
                      //     if (removeFromMenu && modifierID === fbID) {
                      //       console.log('removing from menu', modifier);
                      //       modifierGroup._embedded.modifiers.splice(i, 1);
                      //     } else if (modifierID === fbID) {
                      //       console.log('name change', modifier);
                      //       modifier.name = firebaseModifiers[j].name;
                      //     }
                      //   }
                      // }

                      console.log('done', this.itemModifierGroups);
                      this.itemModifierGroups.push(modifierGroup);
                      // Show Modifiers
                      this.loadingModifiers = false;
                    })
                    .catch(error => {
                      console.log('could not get modifiers', error);
                    });
                })
                .catch(error => {
                  console.log('error', error);
                });
            }
            this.loadingModifiers = false;
          })
          .catch(error => {
            console.log('error', error);
          });
      });
    } else {
      this.state = 'start';
      console.log('yes', this.state);
    }
  }

  public setPricing() {
    // (<any>this.itemModifierGroups)._embedded.modifiers.forEach((modifier) => {
    //   console.log('modifier', modifier);
    // });
  }

  closeAddToOrder() {
    this.state = 'start';
    this.closeOrder.emit({ addToOrderIsActive: false });
    this.selectModifierActive = false;
    this._reset();
  }

  editModifier(modifierGroup, index) {
    this.showModifierError = false;
    console.log('index', index);
    console.log('group', modifierGroup);
    this.currentModifierIndex = index;
    this.selectedModifierGroup = modifierGroup;
    this.selectedModifierMultiple = true ? modifierGroup.minimum > 1 : false;
    // console.log('selectedModifierMultiple', this.selectedModifierMultiple);
    this.selectModifierActive = true;

    this.tempSelectedModifiers = [];

    if (this.selectedModifiers.length !== 0) {
      for (let i = 0; i < modifierGroup._embedded.modifiers.length; i++) {
        let modifier = modifierGroup._embedded.modifiers[i];
        let modifierID = modifier.id;
        let price = modifier.price_per_unit;
        if (price !== 0 && modifier.formatted_price === undefined) {
          let formattedPrice = this._pricingService.formatPrice(price);
          modifier.formatted_price = price;
          console.log('price formatted', modifier);
        }
        for (let j = 0; j < this.selectedModifiers.length; j++) {
          let selectedModifierID = this.selectedModifiers[j].id;
          if (modifierID === selectedModifierID) {
            this.selectedModifiers.splice(j, j + 1);
          }
        }
      }
      console.log('runs new modifiers', this.selectedModifiers);
    }
  }

  private _updateSelectedModifiersLeft(arrayLength, minimum) {
    let maximum = minimum;
    this.selectedModifiers = maximum;
    this.selectedModifiersLeft = maximum - arrayLength;
    if (arrayLength > maximum) {
      return false;
    } else {
      return true;
    }
  }

  public deleteTempModifierEvent($event) {
    console.log('delete temp modifier', $event);
    this.tempSelectedModifiers.splice($event.index, 1);
  }

  public selectedModifierEvent($event) {
    console.log('select modifier', $event);

    let minimum = $event.minimum;

    let modifier = $event.selectedModifier;
    modifier.index = $event.index;

    // Check if there are already some modifiers selected
    if (this.tempSelectedModifiers.length >= 1) {
      // Check if the modifiers max is full
      if ($event.max) {
        this.tempSelectedModifiers = [];
        this.tempSelectedModifiers.push(modifier);
      } else {
        // Check if select field is multiple, if single re assign to empty
        // array and push the selected modifier.
        if (!$event.multiple && $event.addModifier) {
          this.tempSelectedModifiers = [];
          this.tempSelectedModifiers.push(modifier);
        }
        // Check if select field is multiple, and if the selected modifier group is not combos or tacos | if multiple loop through the selected field Array
        if ($event.multiple) {
          if (
            this.selectedModifierGroup.id !== '19' &&
            this.selectedModifierGroup.id !== '41'
          ) {
            this.tempSelectedModifiers.forEach((modifier, index) => {
              if (this._alreadySelectedModifier(modifier, $event)) {
                this.tempSelectedModifiers.splice(index, 1);
              }
            });
          } else {
            this.tempSelectedModifiers.push(modifier);
          }
        }
      }
    } else {
      this.tempSelectedModifiers.push(modifier);
    }
    console.log('temp modifier', this.tempSelectedModifiers);
  }

  private _alreadySelectedModifier(modifier, $event) {
    if (modifier.id === $event.selectedModifier.id && !$event.addModifier) {
      return true;
    }
  }

  public saveModifier() {
    this.showModifierError = false;
    console.log('temp selected modifiers', this.tempSelectedModifiers);
    let newModifiers = this.tempSelectedModifiers;
    // concat the temp selected array to the official selected Modifier array
    // this.selectedModifiers.push.apply(
    //   this.selectedModifiers,
    //   this.tempSelectedModifiers
    // );
    this.selectedModifiers = [
      ...this.tempSelectedModifiers,
      ...this.selectedModifiers,
    ];
    console.log('selected Modifiers', this.selectedModifiers);
    this.selectedModifiersLength = this.selectedModifiers.length;
    this.selectModifierActive = false;

    this.selectedModifiers.forEach(modifier => {
      let price = modifier.price_per_unit;
      if (price !== 0) {
        let formattedPrice = this._pricingService.formatPrice(price);
        modifier.formatted_price = formattedPrice;
      }
      console.log('modifier', modifier);
    });
  }

  /**
   * This function takes in an item to be ordered and checks to make sure the minimum modifier
   * requirements have been met. If not we display an error message for the user to make changes.
   * @param {originalItem} Object
   * @returns boolean
   */
  private _checkRequiredModifiers(originalItem) {
    console.log('ITEM:', originalItem);
    console.log('modifiers length', this.selectedModifiers.length);
    if (originalItem.name === '3 Item Combo' || originalItem.id === '5504') {
      if (this.selectedModifiers.length !== 4) {
        return false;
      } else {
        return true;
      }
    } else if (
      originalItem.name === '2 Item Combo' ||
      originalItem.id === '5503' ||
      originalItem.name === 'Street Tacos' ||
      originalItem.id === '55007'
    ) {
      if (this.selectedModifiers.length !== 3) {
        return false;
      } else {
        return true;
      }
    } else if (
      originalItem.name === '1 Item Combo' ||
      originalItem.id === '5502'
    ) {
      if (this.selectedModifiers.length !== 2) {
        return false;
      } else {
        return true;
      }
    } else if (this.itemModifierGroups.length === 1) {
      if (this.selectedModifiers.length !== 1) {
        return false;
      } else {
        return true;
      }
    } else if (this.itemModifierGroups.length === 0) {
      return true;
    } else {
      console.log('PASSED THE CHECK MODIFIERS FUNC');
      return true;
    }
  }

  addItemToOrder(originalItem) {
    if (!this._checkRequiredModifiers(originalItem)) {
      this.showModifierError = true;
    } else {
      this.showModifierError = false;
      let itemFormattedPrice;
      for (let i = 0; originalItem._embedded.price_levels.length > i; i++) {
        if (originalItem._embedded.price_levels[i].id === this.itemPriceID) {
          itemFormattedPrice =
            originalItem._embedded.price_levels[i].formatted_price;
        }
      }

      let item = {
        name: originalItem.name,
        menu_item: originalItem.id,
        quantity: parseInt(this.itemAmount), // returns a string so we need to convert to number
        price_level: this.itemPriceID,
        formatted_price: itemFormattedPrice,
        comment: '',
        modifiers: [],
      };

      this.selectedModifiers.forEach(modifier => {
        let itemModifier = {
          modifier: modifier.id,
          name: modifier.name,
          quantity: 1,
          price_level: modifier._embedded.price_levels[0].id,
          formatted_price: modifier.formatted_price,
          comment: '',
        };
        item.modifiers.push(itemModifier);
      });

      if (this.itemComment !== '') {
        item.comment = this.itemComment;
      }

      console.log(item);

      try {
        this._orderService.updateOrder(item);
        this.closeOrder.emit({ addToOrderIsActive: false });
        this._reset();
      } catch (err) {
        console.log(err);
      }
    }
  }

  private _reset() {
    this.selectedModifiers = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/add-to-order/add-to-order.component.ts